import React, { Component } from 'react';
import classnames from 'classnames';
import Nav from '../../components/nav/Nav';
import Footer from '../../components/footer/Footer';
import styles from './NotFound.css';

class NotFound extends Component {
  render() {
    return (
      <main className={'animated fadeIn'}>
        <Nav />
        <div className={classnames('container', styles.notFoundContainer)}>
          <p>Sorry, this page doesn't exist.</p>
        </div>
        <Footer />
      </main>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/containers/not-found/NotFound.js